import { z } from 'zod'

export const FormSectionSchema = z.object({
  id: z.string(),
  type: z.literal('form').default('form'),
  title: z.string().optional(),
  fields: z.array(z.string()),
  /**
   * Optional agent config block. When present, an AI autofill button is rendered
   * for this section. The content is opaque to Forecast — it is read by the
   * gong-agent-service via the workflow config.
   */
  agent: z.record(z.string(), z.unknown()).optional(),
  /**
   * When present, the AI autofill banner is only shown to users
   * that hold at least one of these permissions, along with Gecko Internal (by default).
   */
  agentPermissions: z.array(z.string()).optional(),
})

export type FormSection = z.infer<typeof FormSectionSchema>
